/* CartKing's cart:build event is not handled by Ecomus. Refresh the drawer
 * before CartKing inserts its offers, so the section replacement keeps them. */
(function () {
  if (window.__acmerCartKingBridge) return;
  window.__acmerCartKingBridge = true;

  window.CartKingHooks = window.CartKingHooks || [];
  window.CartKingHooks.push({
    hookType: 'before',
    functionName: 'viewUpdateFlow',
    script: function () {
      if (!document.querySelector('hdt-cart-drawer')) return;

      return new Promise(function (resolve) {
        function finished() {
          clearTimeout(timeout);
          document.removeEventListener('cart:drawer:render', finished);
          resolve();
        }

        // Do not leave the app waiting indefinitely if a section request fails.
        var timeout = setTimeout(finished, 5000);
        document.addEventListener('cart:drawer:render', finished);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
    }
  });
})();
